<template>
  <OperativeTableBodyRowKpi class="operative-table-body-kpi-row" :values="values" :strong="strong" :scale="scale" :hide-label="hideLabel" :align="align" :showValues="showValues">
    <template #default><slot></slot></template>
  </OperativeTableBodyRowKpi>
</template>

<script>

export default {
  name: 'operative-table-body-row-kpi-zscore',
  components: {
    OperativeTableBodyRowKpi: () => import('./OperativeTableBodyRowKpi'),
  },
  props: {
    values: {
      type: Array,
      default: () => [],
    },
    strong: {
      type: Boolean,
      default: false,
    },
    hideLabel: {
      type: Boolean,
      default: false,
    },
    align: {
      type: String,
      default: 'default',
    },
    showValues: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      scale: {
        1: { label: 'Alta', rank: 1 },
        2: { label: 'Media-Alta', rank: 2 },
        3: { label: 'Media', rank: 4 },
        4: { label: 'Bassa', rank: 5 },
      },
    };
  },
};

</script>
